export const VAT_MODES = [
    ["21", "21 %", "Základní sazba"],
    ["12", "12 %", "Snížená sazba (bydlení, fyzické osoby)"],
    ["pdp", "Přenesená daňová povinnost", "§ 92e ZDPH — daň odvede zákazník (firma plátce DPH)"],
];
export const VAT_MODE_LABEL = { "21": "21 %", "12": "12 %", pdp: "PDP", "0": "bez DPH" };
export const VAT_MODE_FULL = { "21": "DPH 21 %", "12": "DPH 12 %", pdp: "Přenesená daňová povinnost", "0": "Bez DPH (neplátce)" };

export function VatModeBadge({ mode, testid }) {
    const cls = mode === "pdp" ? "bg-violet-50 text-violet-800 border-violet-300" : mode === "12" ? "bg-emerald-50 text-emerald-800 border-emerald-300" : "bg-slate-100 text-slate-700 border-slate-300";
    return <span data-testid={testid} className={`inline-block px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wider border ${cls}`}>{VAT_MODE_LABEL[mode] || mode}</span>;
}

export function VatModeSelect({ value, onChange, disabled, testid = "vat-mode-select", allowAuto = false }) {
    return (
        <select value={value ?? ""} onChange={(e) => onChange(e.target.value)} disabled={disabled} data-testid={testid}
                className="w-full px-3 py-2 border border-slate-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-orange-600 rounded-sm disabled:opacity-60">
            {allowAuto && <option value="">Automaticky (podle odběratele)</option>}
            {VAT_MODES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
    );
}
